enum FlexControlType {
    RESTRICTION = 'restriction',
    USAGE = 'usage_limit',
    SPENDING = 'spending_limit',
}
export default FlexControlType;
